import React, { useState, useEffect } from "react";

import firebase from "firebase";
import { useDispatch, useSelector } from "react-redux";

import { selectUserData, selectUserType } from "../../features/userSlice";
import { db } from "../../utils/firebase";
import { useHistory } from "react-router";
import "./Messaging.css";
import { Divider } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import sendPushNotification from "../../utils/sendPushNotification";
import formatSpecificDate1 from "../../functions/formatSpecificDate1";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  DialogContentText,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIosRoundedIcon from "@material-ui/icons/ArrowBackIosRounded";
function Messaging({ route, navigation }) {
  const userType = useSelector(selectUserType);
  const userData = useSelector(selectUserData);
  const [inputMessage, setInputMessage] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [from_id, setfrom_id] = useState("");
  const [from_name, setfrom_name] = useState(route?.params?.from_name);
  const [to_id, setto_id] = useState("");
  const [to_name, setto_name] = useState(route?.params?.to_name);
  const [type, settype] = useState();
  const [coachDetails, setCoachDetails] = useState({});

  const [doc_id, setDoc_id] = useState(null);
  const [athleteData, setAthleteData] = useState({});
  const [listOfCoaches, setListOfCoaches] = useState([]);
  const [warningMessage, setWarningMessage] = useState("");
  const [openDialog, setOpenDialog] = React.useState(false);
  const history = useHistory();
  const location = useLocation();
  const [image, setImage] = React.useState("");

  // const Transition = React.forwardRef(function Transition(props, ref) {
  //   return <Slide direction="up" ref={ref} {...props} />;
  // });

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setImage("");
  };

  const keypress = (e) => {
    if (e.key === "Enter") {
      sendMessage(e);
    }
  };
  useEffect(() => {
    setto_id(location.state?.to_id);
    setDoc_id(location.state?.id);
    setfrom_id(location.state?.from_id);
    setfrom_name(location.state?.from_name);
    setto_name(location.state?.to_name);
    settype(location.state?.type);
  }, [location]);

  useEffect(() => {
    if (userType == "athlete") {
      setfrom_id(userData?.data?.listOfCoaches[0]);
      setfrom_name(userData?.data?.name);
      setto_id(userData?.id);
      settype("athlete");
      db.collection("coaches")
        .doc(userData?.data?.listOfCoaches[0])
        .get()
        .then((snap) => {
          setCoachDetails(snap.data());
          setto_name(snap.data().name);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    }
    console.log("1");
    if (from_id && to_id) {
      console.log("2");
      db.collection("chat")
        .where("from_id", "==", from_id)
        .where("to_id", "==", to_id)
        .onSnapshot((snap) => {
          console.log("3");
          if (!snap.empty) {
            snap.forEach(function (doc) {
              setDoc_id(doc.id);
            });
          } else {
            console.log("4");
            db.collection("chat").add({
              from_id: from_id,
              to_id: to_id,
            });

            setAllMessages([]);
          }
        });
      console.log("5");
      db.collection("athletes")
        .doc(from_id)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            console.log("6");
            setListOfCoaches(doc.data().listOfCoaches);
          } else {
            console.log("No such document! gagan");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });

      db.collection("athletes")
        .doc(to_id)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            setAthleteData(doc.data());
          } else {
            console.log("No such document! gagan");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    } else {
      setAllMessages([]);
    }
  }, [doc_id, from_id, to_id]);

  useEffect(() => {
    if (doc_id) {
      const unsubscribe = db
        .collection("chat")
        .doc(doc_id)
        .collection("messages")
        .orderBy("timestamp", "asc")
        .onSnapshot((querySnapshot) => {
          // Get all documents from collection - with IDs
          console.log("Loading the chat...");
          const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));

          console.log(data);
          setAllMessages(data);
        });

      return unsubscribe;
    } else {
      setAllMessages([]);
    }
  }, [db, doc_id]);

  const sendMessage = async () => {
    if (inputMessage !== "") {
      db.collection("chat")
        .where("from_id", "==", from_id)
        .where("to_id", "==", to_id)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            setDoc_id(doc.id);

            if (type === "coach") {
              if (doc.id) {
                db.collection("chat")
                  .doc(doc.id)
                  .collection("messages")
                  .add({
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    message: inputMessage,
                    from_id: to_id,
                    from_name: to_name,
                  })
                  .catch((e) => console.log(e));
              }
            } else if (type === "athlete") {
              if (doc.id) {
                db.collection("chat")
                  .doc(doc.id)
                  .collection("messages")
                  .add({
                    timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                    message: inputMessage,
                    from_id: from_id,
                    from_name: from_name,
                  })
                  .catch((e) => console.log(e));
              }
            }
            if (userType == "coach") {
              var userIdList = [];
              userIdList.push(to_id);
              sendPushNotification(userIdList, {
                title: `New Message`,
                body: `${from_name} : ${inputMessage}`,
              });
            } else {
              var userIdList = [];
              userIdList.push(from_id);
              sendPushNotification(userIdList, {
                title: `New Message`,
                body: `${from_name} : ${inputMessage}`,
              });
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });

      setInputMessage("");
    }
  };

  return (
    <div style={{ minHeight: "99.7vh" }} id="messaging">
      <div style={{ flex: 9 }}>
        <div>
          <div
            style={{
              display: "flex",

              alignItems: "center",
              padding: "5px",
              borderBottomWidth: "1px",
              borderColor: "#707070",
            }}
          >
            <div
              className="messaging__leftArrow"
              onClick={() => {
                if (userType === "athlete") {
                  history.push("/");
                } else {
                  history.goBack();
                }
              }}
              style={{ marginLeft: "10px", marginRight: "10px" }}
            >
              <ArrowBackIosRoundedIcon
                style={{ height: 18, width: 18, padding: 5, cursor: "pointer" }}
              />
            </div>
            <h3
              style={{
                color: "black",
                fontSize: "20px",

                fontWeight: "bold",
                marginLeft: "-3px",
                marginBottom: "23px",
              }}
            >
              {to_name}
            </h3>
          </div>
        </div>
      </div>

      <div
        style={{ height: "82vh", overflowY: "auto", width: 780 }}
        id="scrolldivs"
      >
        {allMessages?.map((msg) => (
          <div key={msg.id}>
            {type === "coach" ? (
              <div style={{ margin: "15px" }}>
                {msg.format && msg.format == "image" ? (
                  msg.message && (
                    <img
                      src={msg.message}
                      style={
                        msg.from_id === to_id
                          ? {
                              // backgroundColor: "black",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                              borderRadius: "15px",
                              alignSelf: "flex-start",
                              color: "white",
                              fontSize: "18px",
                              borderBottomRightRadius: 0,
                              marginRight: "5px",
                              height: "220px",
                              width: "150px",
                              cursor: "pointer",
                            }
                          : {
                              borderRadius: 15,
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                              alignSelf: "flex-end",
                              fontSize: "18px",
                              color: "#63697B",
                              borderBottomLeftRadius: 0,
                              marginLeft: "5px",
                              height: "220px",
                              width: "150px",
                              cursor: "pointer",
                            }
                      }
                      onClick={() => {
                        setImage(msg.message);
                        setOpenDialog(true);
                      }}
                    />
                  )
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        msg.from_id === to_id ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={
                        msg.from_id === to_id
                          ? {
                              backgroundColor: "var(--primarycolor)",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                              borderRadius: "15px",
                              alignSelf: "flex-end",
                              color: "white",
                              fontSize: "18px",
                              borderBottomRightRadius: 0,
                              marginRight: "5px",
                              marginLeft: "300px",
                              fontWeight: "500",
                              textAlign: "end",
                              wordWrap: "break-word",
                              maxWidth: 400,
                            }
                          : {
                              backgroundColor: "#EAECF2",
                              borderRadius: 15,
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                              alignSelf: "flex-start",
                              fontSize: "18px",
                              color: "#63697B",
                              borderBottomLeftRadius: 0,
                              marginLeft: "5px",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              maxWidth: 400,
                            }
                      }
                    >
                      {msg.message}
                    </div>
                  </div>
                )}
                {/* <Text
                style={
                  msg.from_id === to_id
                    ? {
                        alignSelf: "flex-end",
                      }
                    : {
                        alignSelf: "flex-start",
                      }
                }
              >
                {msg.timestamp}
              </Text> */}
              </div>
            ) : (
              <div style={{ margin: "15px" }}>
                {msg.format && msg.format == "image" ? (
                  <img
                    src={msg.message}
                    style={
                      msg.from_id === to_id
                        ? {
                            // backgroundColor: "black",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            borderRadius: "15px",
                            alignSelf: "flex-start",
                            color: "white",
                            fontSize: "18px",
                            borderBottomRightRadius: 0,
                            marginRight: "5px",
                            height: "220px",
                            width: "150px",
                            fontWeight: "500",
                            objectFit: "contain",
                            cursor: "pointer",
                          }
                        : {
                            borderRadius: "15px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            alignSelf: "flex-end",
                            fontSize: "18px",
                            color: "#63697B",
                            borderBottomLeftRadius: 0,
                            marginLeft: "5px",
                            height: "220px",
                            width: "150px",
                            fontWeight: "500",
                            objectFit: "contain",
                            cursor: "pointer",
                          }
                    }
                    onClick={() => {
                      setImage(msg.message);
                      setOpenDialog(true);
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        msg.from_id === from_id ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={
                        msg.from_id === from_id
                          ? {
                              backgroundColor: "black",
                              paddingLeft: "15px",
                              paddingRight: "15px",
                              paddingTop: "10px",
                              paddingBottom: "10px",
                              borderRadius: "15px",
                              alignSelf: "flex-grow",
                              color: "white",
                              fontSize: "18px",
                              borderBottomRightRadius: 0,
                              marginRight: "5px",
                              marginLeft: "300px",
                              height: "fit-content",
                              textAlign: "end",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              maxWidth: 400,
                            }
                          : {
                              backgroundColor: "#EAECF2",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              paddingTop: "5px",
                              paddingBottom: "5px",
                              borderRadius: "15px",
                              alignSelf: "flex-start",
                              fontSize: "18px",
                              color: "#63697B",
                              borderBottomLeftRadius: 0,
                              marginLeft: "5px",
                              width: "fit-content",
                              textAlign: "start",
                              fontWeight: "500",
                              wordWrap: "break-word",
                              maxWidth: 400,
                            }
                      }
                    >
                      {msg.message}
                    </div>
                    {/* <div
                      style={{
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        borderRadius: "15px",
                        alignSelf: "flex-grow",
                        color: "white",
                        fontSize: "12px",
                        borderBottomRightRadius: 0,
                        marginRight: "5px",
                        marginLeft: "300px",
                        height: "fit-content",
                        textAlign: "end",
                        fontWeight: "500",
                        color: "black",
                      }}
                    >
                      {formatSpecificDate1(
                        new Date(msg.timestamp.seconds * 1000)
                      )}
                    </div> */}
                  </div>
                )}
                {/* <Text
                style={
                  msg.from_id === from_id
                    ? {
                        alignSelf: "flex-end",
                      }
                    : {
                        alignSelf: "flex-start",
                      }
                }
              >
                {msg.timestamp}
              </Text> */}
              </div>
            )}
          </div>
        ))}
      </div>
      {warningMessage ? (
        <h3 style={{ color: "yellow" }}>{warningMessage}</h3>
      ) : null}
      <div
        className="messagebarcontainer"
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "white",
          justifyContent: "space-between",
          paddingLeft: "10px",
          paddingRight: "10px",
          flex: 1,
          marginLeft: "10px",
          paddingTop: "5px",
          paddingBottom: "10px",
          paddingRight: 10,
          // position: "relative",
          // bottom: "30px",
          position: "relative",
          bottom: 10,
        }}
      >
        <div
          className="messaging__bar"
          style={{ display: "10px", alignItems: "center", width: "100%" }}
        >
          <input
            onKeyPress={keypress}
            style={{
              color: "black",
              width: "100%",
              marginLeft: "10px",
            }}
            placeholder="Type something..."
            placeholderTextColor="black"
            value={inputMessage}
            onChange={(e) => {
              setInputMessage(e.target.value);
            }}
          />
          <div
            className="messaging__sendMessage"
            onClick={(e) => sendMessage(e)}
            style={{ width: "10%" }}
          >
            <img
              src="/assets/Send.png"
              alt=""
              style={{
                width: "27px",
                height: "25px",
                marginTop: "11px",
                marginRight: "4px",
              }}
            />
          </div>
        </div>
      </div>
      <Dialog
        open={openDialog}
        // TransitionComponent={Transition}
        keepMounted
        maxWidth="md"
        // fullWidth
        onClose={handleCloseDialog}
      >
        <DialogContent>
          {/* <video width="500" height="500" controls>
            <source src={workoutVideoUrl} type="video/mp4" />
          </video> */}
          {/* <div
              dangerouslySetInnerHTML={{
                __html: `<iframe title="video" height="470" width="730" frameborder="0" src="https://player.vimeo.com/video/${workoutVideoUrl.substring(
                  workoutVideoUrl.lastIndexOf("/") + 1
                )}"></iframe>`,
              }}
            /> */}

          {/* <ReactPlayer
            // title={video.title}
            // id="iframe"
            style={{ borderRadius: 10 }}
            url={"https://player.vimeo.com/video/" + workoutVideoUrl}
            width="600px"
            height="400px"
            frameborder="0"
            controls
          /> */}
          <img src={image} alt="" width="500" height="600" />

          <div
            onClick={handleCloseDialog}
            style={{
              cursor: "pointer",
              position: "absolute",
              right: 0,
              top: 0,
              padding: 12,
            }}
          >
            {" "}
            <CloseIcon />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Messaging;
